import { render, staticRenderFns } from "./add-production-unit-form.vue?vue&type=template&id=331bd520&scoped=true"
import script from "./add-production-unit-form.vue?vue&type=script&lang=js"
export * from "./add-production-unit-form.vue?vue&type=script&lang=js"
import style0 from "./add-production-unit-form.vue?vue&type=style&index=0&id=331bd520&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331bd520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331bd520')) {
      api.createRecord('331bd520', component.options)
    } else {
      api.reload('331bd520', component.options)
    }
    module.hot.accept("./add-production-unit-form.vue?vue&type=template&id=331bd520&scoped=true", function () {
      api.rerender('331bd520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/edit-poppers/add-production-unit-form.vue"
export default component.exports